/** Enlace para abrir la ubicación en Google Maps (nueva pestaña). */
export function buildGoogleMapsSearchUrl(address) {
  const q = String(address || '').trim();
  if (!q) return 'https://www.google.com/maps';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

/**
 * URL de iframe sin API key (Embed API v1 requiere clave válida en Google Cloud).
 * Usa el formato clásico output=embed.
 */
export function buildGoogleMapsEmbedUrl(address) {
  const q = String(address || '').trim();
  if (!q) return '';
  return `https://maps.google.com/maps?q=${encodeURIComponent(q)}&hl=es&z=15&ie=UTF8&iwloc=&output=embed`;
}
